<template>
  <div class="container-fluid container-md mt-4 px-3 px-md-5 py-3">
    <div class="row align-items-center">
      <div class="col-12 col-md-6 mb-4 mb-md-0">
        <div class="d-flex align-items-md-start align-items-center justify-content-center justify-content-md-center">
          <div class="me-3">
            <img src="../assets/images/star.png" alt="Star" class="img-fluid" style="max-width: 40px;">
          </div>
          <div class="text-start">
            <div class="fs-5">{{ $t('slogan-1') }}</div>
            <div class="fs-5">{{ $t('slogan-2') }}</div>
            <div class="mt-2 fs-4 fw-bold">{{ $t('slogan-3') }}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 text-center text-md-end" style="z-index: 99;">
        <img src="../assets/images/idea-light.png" alt="Idea Light" class="img-fluid idea-light-img">
      </div>
    </div>


  </div>
  <div class="service-content">
    <div class="d-flex justify-content-center">
      <div class="w-100" style="max-width: 1280px;">
        <div class="service-title-outer">
          <div class="service-title-with-image">
            <div class="fs-4 text-white text-align-justify" style="width: 130px;">
              {{ $t('services') }}
            </div>
          </div>
        </div>

        <div class="mt-2 mb-5 container-fluid d-flex justify-content-center mx-0 px-0">
          <div class="w-100" style="max-width: 995px;">

            <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 justify-content-around g-4 mx-0">
              <div class="col" v-for="(item, index) in $tm('what-we-can-do')" :key="index">
                <div class="card border-0 bg-transparent fill-service" style="overflow: hidden; cursor: pointer;" data-bs-toggle="modal"
                  data-bs-target="#IntroDetailModal" @click="showDetail(item)">
                  <div class="card-body px-0">
                    <div class="w-100 text-end" style="position: relative; z-index: 2; margin-top: 16px;">
                      <div class="pe-2 one-service-title"> {{ item.title }} </div>
                    </div>
                    <div style="z-index: 1; position: absolute;" :style="{ left: item['img-x'] + 'px', top: item['img-y'] + 'px' }">
                      <img :src="item.img">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

  <IntroDetailModal ref="detailModal" />
</template>

<script>
import IntroDetailModal from './IntroDetailModal.vue';

export default {
  components: { IntroDetailModal },
  data() {
    return {
    }
  },
  methods: {
    showDetail(item) {
      console.log("onclick", item.title);
      this.$refs.detailModal.setDetail(item);
    }
  }
};
</script>

<style>
.service-content {
  margin-top: -60px;
  width: 100%;
  background-color: #d9d9d9;
}

.service-title-outer {
  padding-top: 40px;
}

.service-title-with-image {
  background-image: url('../assets/images/service-title.png');
  height: 55px;
  width: 296px;
  padding-left: 150px;
  padding-top: 2px;
  margin-left: 219px;
}

.text-align-justify {
  text-align-last: justify;
}

.fill-service {
  background-image: url('../assets/images/ourservice-bg.svg');
  width: 297px;
  height: 216px;
  margin-left: auto;
  margin-right: auto;
}

.non-service {
  background-image: url('../assets/images/service-none.svg');
}

.one-service-title {
  background-color: #10638F;
  width: 200px;
  font-size: 18px;
  min-height: 22px;
  height: auto;
  color: white;
}

@media (max-width: 767.98px) {
  .idea-light-img {
    max-width: 360px;
    width: 100%;
    height: auto;
  }

  .service-title-with-image {
    background-image: url('../assets/images/service-title.png');
    height: 55px;
    width: 296px;
    padding-left: 150px;
    padding-top: 2px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>